export const NormalHoursPerMonth = 168;
export const AdminWarningForAlteringDeviationsWhenMonthSubmitted =
  "AdminWarningForAlteringDeviationsWhenMonthSubmitted";
